(() => {
  'use strict';
  const storageKey = 'martenbrown-unverbindliche-vorbestellung-v1';
  const validQuantity = value => Number.isInteger(value) && value >= 1 && value <= 999;
  function init() {
    const root = document.querySelector('[data-mb-reservation]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const success = root.querySelector('[data-mb-success]');
    if (success) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      success.focus();
      return;
    }
    const form = root.querySelector('#MBReservationForm');
    const rows = form?.querySelector('[data-mb-rows]');
    const firstRow = rows?.querySelector('[data-mb-row]');
    if (!firstRow) return;
    const t = JSON.parse(root.querySelector('[data-mb-translations]').textContent);
    const rowTemplate = firstRow.cloneNode(true);
    const readCatalogue = options => new Map([...options]
      .filter(o => o.dataset.key).map(o => [o.dataset.key, Object.freeze({
        value: o.value,
        label: o.dataset.mbTitle || o.textContent.trim(),
        productKey: o.dataset.productKey,
        priceCents: Number(o.dataset.mbPriceCents),
        price: o.dataset.mbPrice || '',
        unitPrice: o.dataset.mbUnitPrice || ''
      })]));
    let catalogue = readCatalogue(firstRow.querySelector('select').options);
    const formatter = new Intl.NumberFormat(root.dataset.mbLocale, { style: 'currency', currency: root.dataset.mbCurrency });
    // Old links and saved lists identify a product; new rows identify its exact
    // variant. Preserve old links by selecting the first variant of the product.
    const productKeys = new Map();
    const updateProductKeys = () => {
      productKeys.clear();
      catalogue.forEach((item, key) => { if (!productKeys.has(item.productKey)) productKeys.set(item.productKey, key); });
    };
    updateProductKeys();
    const resolveKey = key => catalogue.has(key) ? key : productKeys.get(key) || '';
    let maxRows = catalogue.size;
    const add = form.querySelector('[data-mb-add]');
    const submit = form.querySelector('[data-mb-submit]');
    const submitLabel = submit.textContent;
    const error = form.querySelector('[data-mb-error]');
    const reference = form.querySelector('[data-mb-reference]');
    reference.value = `MB-${globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2,10)}`}`;
    let submitting = false;
    let pendingSubmit = null;
    let lastRefresh = Date.now();
    let refreshing = null;
    const readRows = () => [...rows.querySelectorAll('[data-mb-row]')].map(row => {
      const option = row.querySelector('select').selectedOptions[0];
      const known = catalogue.get(option?.dataset.key);
      return {key: known?.value === option?.value ? option.dataset.key : '', qty: Number(row.querySelector('[data-mb-quantity]').value)};
    });
    const save = () => {
      const items = readRows().filter(item => catalogue.has(item.key) && validQuantity(item.qty));
      try { sessionStorage.setItem(storageKey, JSON.stringify({at: Date.now(), items})); } catch (_) {}
    };
    const showError = message => {error.textContent = message; error.hidden = !message;};
    const clearValidity = () => {rows.querySelectorAll('select,input').forEach(input => input.setCustomValidity('')); showError('');};
    const updatePrices = row => {
      const option = row.querySelector('select').selectedOptions[0];
      const item = catalogue.get(option?.dataset.key);
      const panel = row.querySelector('[data-mb-prices]');
      const known = item && item.value === option?.value && Number.isInteger(item.priceCents) && item.priceCents >= 0;
      panel.hidden = !known;
      row.querySelector('[data-mb-price-each]').textContent = known ? item.price : '';
      row.querySelector('[data-mb-price-unit]').textContent = known ? item.unitPrice : '';
      row.querySelector('[data-mb-unit-price-row]').hidden = !known || !item.unitPrice;
      const status = row.querySelector('[data-mb-price-status]');
      status.textContent = option?.dataset.key && !known ? t.no_longer_available : '';
      status.hidden = !status.textContent;
      const qty = Number(row.querySelector('[data-mb-quantity]').value);
      const lineTotal = known && validQuantity(qty) ? formatter.format(item.priceCents * qty / 100) : '';
      row.querySelector('[data-mb-line-total]').textContent = lineTotal;
      row.querySelector('[data-mb-line-total-row]').hidden = !lineTotal;
    };
    const update = () => {
      clearValidity();
      const allRows = [...rows.querySelectorAll('[data-mb-row]')];
      allRows.forEach((row,i) => {
        const n=i+1;
        const select=row.querySelector('select');
        const qty=row.querySelector('[data-mb-quantity]');
        row.querySelector('legend').textContent=t.article.replace('__NUMBER__',n);
        select.id=`MBProduct-${n}`; select.name=`contact[Artikel ${n}]`;
        qty.id=`MBQuantity-${n}`; qty.name=`contact[Menge ${n}]`;
        row.querySelectorAll('label')[0].htmlFor=select.id;
        row.querySelectorAll('label')[1].htmlFor=qty.id;
        row.querySelector('[data-mb-remove]').hidden=allRows.length===1;
        updatePrices(row);
      });
      add.hidden=false; add.disabled=allRows.length>=maxRows;
      save();
    };
    const appendItem = (item={}) => {
      if (rows.children.length>=maxRows) return;
      const row=rowTemplate.cloneNode(true);
      row.querySelector('select').value=catalogue.get(item.key)?.value || '';
      row.querySelector('[data-mb-quantity]').value=validQuantity(item.qty)?item.qty:1;
      rows.append(row);
    };
    const refreshPrices = (force = false) => {
      if (refreshing) return refreshing;
      if (!root.dataset.mbSectionId || submitting || pendingSubmit || (!force && Date.now() - lastRefresh < 60000)) return Promise.resolve();
      const url = new URL(location.href);
      // Preserve locale and preview context, but never send contact data or old
      // product selection parameters to this read-only section request.
      ['artikel', 'variante', 'menge', 'contact_posted', 'form_type', 'utf8', 'page'].forEach(key => url.searchParams.delete(key));
      url.hash = '';
      url.searchParams.set('section_id', root.dataset.mbSectionId);
      url.searchParams.set('_mb_prices', String(Date.now()));
      const status = form.querySelector('[data-mb-refresh-status]');
      refreshing = fetch(url.href, { credentials: 'same-origin', cache: 'no-store' })
        .then(response => { if (!response.ok) throw new Error('Prices unavailable'); return response.text(); })
        .then(html => {
          if (submitting || pendingSubmit || !root.isConnected) return;
          const freshRoot = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mb-reservation]');
          const freshSelect = freshRoot?.querySelector('[data-mb-options]')?.content.querySelector('select');
          if (!freshSelect) throw new Error('Price catalogue unavailable');
          const nextCatalogue = readCatalogue(freshSelect.options);
          // Capture current choices only after the response: customers may have
          // selected, added or removed a row while the request was in flight.
          const selections = [...rows.querySelectorAll('[data-mb-row]')].map(row => ({
            row, option: row.querySelector('select').selectedOptions[0]?.cloneNode(true)
          }));
          catalogue = nextCatalogue;
          maxRows = catalogue.size;
          updateProductKeys();
          rowTemplate.querySelector('select').replaceChildren(...[...freshSelect.options].map(option => option.cloneNode(true)));
          selections.forEach(({ row, option }) => {
            const select = row.querySelector('select');
            select.replaceChildren(...[...freshSelect.options].map(option => option.cloneNode(true)));
            const item = catalogue.get(option?.dataset.key);
            if (item) select.value = item.value;
            else if (option?.dataset.key) {
              option.textContent = (option.dataset.mbTitle || option.textContent) + ' – ' + t.no_longer_available;
              select.append(option);
              select.value = option.value;
            } else select.value = '';
          });
          lastRefresh = Date.now();
          status.textContent = ''; status.hidden = true;
          update();
        }).catch(() => {
          status.textContent = t.refresh_failed; status.hidden = false;
        }).finally(() => { refreshing = null; });
      return refreshing;
    };
    let saved=[];
    try {
      const data=JSON.parse(sessionStorage.getItem(storageKey)||'null');
      const age=Date.now()-data?.at;
      const seen=new Set();
      if (data && age>=0 && age<7*86400000 && Array.isArray(data.items)) saved=data.items.flatMap(item=>{
        const key = resolveKey(item?.key);
        if (!key || !validQuantity(item?.qty) || seen.has(key)) return [];
        seen.add(key); return [{key, qty: item.qty}];
      }).slice(0,maxRows);
    } catch (_) {}
    const params=new URLSearchParams(location.search);
    const incoming=params.get('artikel');
    const incomingVariant=params.get('variante');
    const incomingKey=params.has('variante')
      ? (catalogue.has(incomingVariant) && (!incoming || catalogue.get(incomingVariant).productKey===incoming) ? incomingVariant : '')
      : resolveKey(incoming);
    if(incomingKey) {
      const existing=saved.find(item=>item.key===incomingKey);
      const qty=params.has('menge')||!existing?Number(params.get('menge')||1):existing.qty;
      saved=[{key:incomingKey,qty:validQuantity(qty)?qty:1},...saved.filter(item=>item.key!==incomingKey)];
    }
    if(saved.length) {rows.replaceChildren();saved.slice(0,maxRows).forEach(appendItem);}
    update();
    if((incoming||params.has('variante'))&&!incomingKey) showError(t.unknown_link);
    add.addEventListener('click',()=>{appendItem();update();rows.lastElementChild.querySelector('select').focus();});
    rows.addEventListener('change',update);
    rows.addEventListener('focusin',event=>{if(event.target.matches('[data-mb-select]')) refreshPrices();});
    rows.addEventListener('input',event=>{if(event.target.matches('[data-mb-quantity]')){clearValidity();updatePrices(event.target.closest('[data-mb-row]'));save();}});
    rows.addEventListener('click',event=>{
      const remove=event.target instanceof Element&&event.target.closest('[data-mb-remove]');
      if(!remove||rows.children.length<2)return;
      remove.closest('[data-mb-row]').remove();update();add.focus();
    });
    form.addEventListener('submit',event=>{
      if(submitting||(pendingSubmit&&!pendingSubmit.defaultPrevented)){event.preventDefault();return;}
      clearValidity();
      const items=readRows();const seen=new Set();let message='';
      [...rows.querySelectorAll('[data-mb-row]')].forEach((row,i)=>{
        const item=items[i];const select=row.querySelector('select');const qty=row.querySelector('[data-mb-quantity]');
        if(!catalogue.has(item.key)){select.setCustomValidity(t.invalid_product);message ||= t.invalid_product;}
        else if(seen.has(item.key)){select.setCustomValidity(t.duplicate);message ||= t.duplicate;}
        seen.add(item.key);
        if(!validQuantity(item.qty)){qty.setCustomValidity(t.invalid_quantity);message ||= t.invalid_quantity;}
      });
      if(!items.length||items.length>maxRows)message ||= t.invalid_form;
      if(!form.reportValidity()||message){event.preventDefault();showError(message||t.invalid_form);return;}
      form.querySelector('[data-mb-time]').value=new Date().toISOString();
      const lines=['MARTENBROWN_VORMERKUNG_V1',`Referenz: ${reference.value}`,'Kostenlose, unverbindliche Vormerkung. Keine Zahlung, noch kein Kaufvertrag.',''];
      items.forEach((item,i)=>{
        const product=catalogue.get(item.key);
        lines.push(`${i+1}. ${product.label} | ${item.qty} Stück | Produkt-ID: ${product.productKey} | Varianten-ID: ${item.key}`);
        lines.push(`Aktueller Preis je Artikel: ${product.price}${product.unitPrice ? ` | Grundpreis: ${product.unitPrice}` : ''}`);
        lines.push('15 % Rabatt beim späteren Kauf | wieder erhältlich frühestens ab März 2027.');
      });
      lines.push('','Rabatt auf die hier vorgemerkten Artikel beim späteren Kauf.','Genauen Termin, Verfügbarkeit und endgültigen Preis vor dem Kauf bestätigen.');
      form.querySelector('[data-mb-summary]').value=lines.join('\n');
      save();pendingSubmit=event;
      queueMicrotask(()=>{
        if(event.defaultPrevented){if(pendingSubmit===event)pendingSubmit=null;return;}
        submitting=true;submit.disabled=true;submit.setAttribute('aria-busy','true');submit.textContent=t.submitting;
      });
    });
    window.addEventListener('pageshow',event=>{
      submitting=false;pendingSubmit=null;submit.disabled=!catalogue.size;
      submit.removeAttribute('aria-busy');submit.textContent=submitLabel;
      if (event.persisted) refreshPrices(true);
    });
    window.addEventListener('focus',()=>refreshPrices());
    document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible') refreshPrices();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
